import React from 'react'
import {
  Label,
  Input,
  FormFeedback,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap'
import {
  Controller,
  FieldValues,
  Control,
  FieldErrors,
  UseFormSetValue,
  UseFormGetValues,
  UseFormSetError
} from 'react-hook-form'
import ICSToolTip from '../ICSToolTip/ICSToolTip'

const ICSTextAreaInput = ({
  name,
  id = `${name}Input`,
  placeholder = `${name.charAt(0).toUpperCase() + name.slice(1)}...`,
  control,
  defaultValue = '',
  errors,
  isSubmitted,
  helpText,
  autoComplete = 'off',
  maxCharCount = 0,
  label
}: ICSTextAreaInputProps) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState: { invalid, isTouched }
      }) => {
        return (
          <>
            <Label for={id} className="input-label">
              {label}
              {helpText && (
                <ICSToolTip
                  id={`${name}ToolTip`}
                  text={helpText}
                  target={`#${name}ToolTip`}
                />
              )}
            </Label>
            <InputGroup>
              <Input
                id={id}
                onBlur={onBlur}
                onChange={onChange}
                placeholder={placeholder}
                type="textarea"
                valid={
                  !invalid &&
                  (isTouched || isSubmitted) &&
                  value !== defaultValue
                }
                value={value}
                invalid={invalid && (isTouched || isSubmitted)}
                innerRef={ref}
                autoComplete={autoComplete}
                style={{ color: 'black' }}
              />
              {maxCharCount > 0 && (
                <InputGroupAddon addonType="append">
                  <InputGroupText id={`${name}CharCount`}>
                    {value?.length || 0}/{maxCharCount}
                  </InputGroupText>
                </InputGroupAddon>
              )}

              <FormFeedback
                valid={errors?.[name] ? false : true}
                role="alert"
                id={`${name}Error`}
              >
                {errors?.[name]?.message}
              </FormFeedback>
            </InputGroup>
          </>
        )
      }}
    />
  )
}

export default ICSTextAreaInput

type ICSTextAreaInputProps<TFieldValues extends FieldValues = FieldValues> = {
  id?: string
  name: string
  control?: Control<TFieldValues>
  errors?: FieldErrors<TFieldValues>
  defaultValue?: string
  placeholder?: string
  helpText?: string
  isSubmitted?: boolean
  autoComplete?: string
  maxCharCount?: number
  setValue?: UseFormSetValue<FieldValues>
  getValues?: UseFormGetValues<FieldValues>
  setError?: UseFormSetError<FieldValues>
  label?: string
}
